import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { IUserInfo } from '../../../shared/models/contact';
import { IFile, IDrillReport } from '../../../shared/models/schedule';
import { CommonModule, DatePipe } from '@angular/common';
import { FilesService } from '../../../shared/services/files.service';
import { UserDataService } from '../../../shared/services/userData.service';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'report-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  providers: [DatePipe],
  templateUrl: './report-details.component.html',
  styleUrl: './report-details.component.css'
})
export class ReportDetailsComponent implements OnInit {
  icons = Icons;
  formattedStartDate: string | null = null;
  formattedEndDate: string | null = null;
  currentUser: IUserInfo | null = null;

  @Input() eventDetails: IDrillReport| null = null;
  
  @Output() onClose = new EventEmitter<void>();
  @Output() onOpenModal = new EventEmitter<{ modalName: string, selectedItem: IDrillReport, itemType?: string }>();

  constructor(
    private datePipe: DatePipe,
    private filesService: FilesService,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userDataService.getUserData();
    if (this.eventDetails?.start_date) {
      this.formattedStartDate = this.dateTypeToDisplay(this.eventDetails?.start_date);
      this.formattedEndDate = this.dateTypeToDisplay(this.eventDetails?.end_date); 
      if (this.formattedStartDate) {
        this.eventDetails.start_date = this.formattedStartDate;
      } else {
        console.error('unsuccess to format start_date');
      }
      if (this.formattedEndDate) {
        this.eventDetails.end_date = this.formattedEndDate;
      } else {
        console.error('unsuccess to format end_date');
      }
    }   
  }
  
  downloadFile(file: IFile): void {
    this.filesService.downloadFile(String(file.building_id), String(file.section_id), file.id).subscribe({
      next: (res) => {
        if (!res.has_error && res.data?.signed_url) {
          window.open(res.data.signed_url, '_blank');
        } else {
          console.error('Error downloading file:', res.message);
        }
      },
      error: (err) => {
        console.error('Download failed:', err);
      }
    });
  }


  closeDetails(): void {
    this.onClose.emit();
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  handleBtnClick(modalName: string, selectedItem: any, itemType?: string): void {
    this.onOpenModal.emit({ modalName, selectedItem, itemType });
  }

  dateTypeToDisplay(date: any): string | null {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

}
